<template>
  <svg width="34px" height="34px" viewBox="0 0 34 34" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>gas station</title>
    <desc>Created with Sketch.</desc>
    <g id="neighborhood" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="neighborhood-poi-desktop" transform="translate(-849.000000, -717.000000)">
        <g id="map" transform="translate(0.000000, 612.000000)">
          <g id="POIs">
            <g transform="translate(771.000000, 107.000000)">
              <g id="gas-station" transform="translate(80.000000, 0.000000)">
                <circle id="Oval-Copy-5" stroke="#FFFFFF" stroke-width="2" fill="#9F8054" cx="15" cy="15" r="16"></circle>
                <path d="M11.2142773,12.3571387 L16.571416,12.3571387 L16.571416,9.14286133 L11.2142773,9.14286133 L11.2142773,12.3571387 Z M19.7856641,11.2856934 L19.7856641,15.5713867 C19.7856641,16.1620117 19.3049023,16.642832 18.714248,16.642832 L18.714248,8.07144531 C18.7142773,7.47967773 18.2345996,7 17.642832,7 L10.1428613,7 C9.55109375,7 9.07144531,7.47967773 9.07144531,8.07144531 L9.07144531,19.8571094 L8.98217773,19.8571094 C8.4397168,19.8571094 8,20.3367578 8,20.9285547 L8,22 L19.7856641,22 L19.7856641,20.9285547 C19.7856641,20.3368164 19.3459473,19.8571094 18.8035156,19.8571094 L18.7142773,19.8571094 L18.7142773,18.7856641 C20.4867383,18.7856641 21.9285547,17.3438477 21.9285547,15.5713867 L21.9285547,11.2856934 C21.9285547,10.6950391 22.4093164,10.214248 23,10.214248 L23,8.07144531 C21.2275098,8.07144531 19.7856641,9.51326172 19.7856641,11.2856934 L19.7856641,11.2856934 Z" id="Fill-1" fill="#FFFFFF"></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'IconPoiGas',
};
</script>

<style></style>
